import styles from "./ReassignmentModal.module.css";

import { useState } from "react";

import { fetchSalesPersonByUserId } from "../../../Services/Dashboard/tableGridService";
import InputWithSearch from "../../InputWithSearch";

const ReassignmentModal = ({ verticals,  reportingSalesPersonData, remapFn}) => {
  const [verticalsClone, setVerticalsClone] = useState(verticals.map((vertical) => ({
    ...vertical,
    userId: reportingSalesPersonData?.userId,
    userName: reportingSalesPersonData?.empName,
    salesPersonId: reportingSalesPersonData?.id,
  })));
  const [isLoading, setIsLoading] = useState(false);
  
  const onChangeUserId = (event, index) => {
    setVerticalsClone((state) => {
      const stateCopy = state.slice();
      stateCopy[index].userId = event?.target?.value;
      stateCopy[index].userName = '';
      stateCopy[index].salesPersonId = null;
      stateCopy[index].isAssigned = false;
      return stateCopy;
    });
  };
  const onChangeUserName = (value, index) => {
    const stateCopy = verticalsClone.slice();
    stateCopy[index].userName = value?.userName;
    stateCopy[index].salesPersonId = value?.salesPersonId;
    setVerticalsClone(stateCopy);
  };
  const onSearchUser = async (index) => {
    const vertical = verticalsClone[index];
    setIsLoading(true);
    if (!!vertical.userId) {
      try {
        const res = await fetchSalesPersonByUserId(vertical.userId);
        setIsLoading(false);
        if (res?.data?.data?.length) {
          const obj = res?.data?.data[0];
          onChangeUserName({userName: obj?.empName, salesPersonId: obj?.id}, index)
        } else {
          onChangeUserName({}, index)
        }
      } catch(err) {
        setIsLoading(false);
        throw err;
      }
    }
  };
  const disableAssignBtn = (index) => {
    return !(
      !!verticalsClone[index]?.salesPersonId &&
      !!verticalsClone[index]?.userId &&
      !!verticalsClone[index]?.userName
    );
  }
  const onAssign = (index) => {
      const vc = verticalsClone.slice();
      vc[index].isAssigned = true;
      setVerticalsClone(vc);
  }
  const isEnableSubmit = () => {
    return verticalsClone.every(vertical => !!vertical?.isAssigned);
  }

  const onSubmit = () => {
    setIsLoading(true);
    const body = verticalsClone.map(vertical => {
      return {
        to: {
          salesPersonId: vertical.salesPersonId,
          positionCodeId:
            vertical?.positionCodeAdditionalDetails[0]?.positionCodeId,
        },
        from: {
          salesPersonId: vertical?.id,
          positionCodeId:
            vertical?.positionCodeAdditionalDetails[0]?.positionCodeId,
        },
      };
    });
    remapFn(body);
  }

  return (
    <div className={styles["reassignment-wrapper"]}>
      <p>You have removed:</p>
      {verticalsClone?.map((vertial, index) => {
        const { positionCodeAdditionalDetails } = vertial;
        return (
          <div
            key={vertial.uniqueId}
            className={"flex items-center justify-center"}
          >
            {positionCodeAdditionalDetails?.map((detail, idx) => (
              <div key={idx} className={styles["form-container"]}>
                <label>{detail?.refType}</label>
                <input
                  name={detail?.refType}
                  value={detail?.refValue}
                  disabled
                />
              </div>
            ))}
            <div className={styles["form-container"]}>
              <label>Asgard ID</label>
              <InputWithSearch
                placeholder="Search"
                value={vertial.userId}
                onChange={(e) => onChangeUserId(e, index)}
                onSearchFn={() => onSearchUser(index)}
              />
            </div>
            <div className={styles["form-container"]}>
              <label>Name</label>
              <input name="userName" value={vertial.userName} disabled />
            </div>
            <button
              type="button"
              disabled={disableAssignBtn(index) || vertial?.isAssigned}
              className={styles["assign-btn"]}
              onClick={onAssign.bind(this, index)}
            >
              {vertial?.isAssigned ? "Assigned" : "Assign"}
            </button>
          </div>
        );
      })}
      <div className="flex items-center justify-center">
        <button type="button" disabled={!isEnableSubmit()} className={styles["done-btn"]}
        onClick={onSubmit}>
          Done
        </button>
      </div>
     {(!verticals.length || isLoading) && <div className={styles['loading-overlay']}>
      <p>Loading...</p>
      </div>}
    </div>
  );
};

export default ReassignmentModal;
